import React, { useContext } from "react"

import { Layout, Dropdown, Menu, Avatar } from "antd"
import { FaCogs, FaKey, FaSignOutAlt, FaUser } from "../../components/icons"
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons"

import AppContext from "../../utils/context"

const { Header } = Layout

const DefaultHeader = ({ isCollapsed, collapse }) => {
  const MenuIcon = isCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined

  const appContext = useContext(AppContext)

  return (
    <Header className="site-layout-header" style={{ padding: 0 }}>
      <MenuIcon className="trigger" onClick={() => collapse((x) => !x)} />
      <Dropdown
        trigger={["click"]}
        placement="bottomLeft"
        overlay={
          <Menu className="header-avatar-menu">
            {(["admin", "sys_admin"].includes(appContext.user?.role) || appContext.user?.usertype === "A") && (
              <>
                <Menu.Item icon={<FaCogs />} key="0">
                  <a href="/admin">Yönetim</a>
                </Menu.Item>
                <Menu.Divider />
              </>
            )}
            <Menu.Item icon={<FaKey />} key="1">
              <a href="/profile">Profil</a>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item icon={<FaSignOutAlt />} key="2">
              <a href="/logout">Çıkış Yap</a>
            </Menu.Item>
          </Menu>
        }
      >
        <a className="ant-dropdown-link header-avatar" onClick={(e) => e.preventDefault()}>
          <span>{`${appContext.user?.firstname} ${appContext.user?.lastname} `}</span>
          <Avatar size={36} style={{ backgroundColor: "#555" }} icon={<FaUser />} />
        </a>
      </Dropdown>
    </Header>
  )
}

export default DefaultHeader
